(() => {
  const directions = new Map([
    ['↗', 'up-right'],
    ['→', 'right'],
    ['←', 'left'],
    ['↑', 'up'],
    ['↓', 'down']
  ]);
  const arrowPattern = /[↗→←↑↓]/g;

  function makeArrow(character) {
    const icon = document.createElement('span');
    icon.className = 's-vector-arrow';
    icon.dataset.direction = directions.get(character) || 'up-right';
    icon.setAttribute('aria-hidden', 'true');
    return icon;
  }

  function upgradeControl(control) {
    if (!(control instanceof Element) || !control.matches('a, button')) return;
    if (!arrowPattern.test(control.textContent || '')) {
      arrowPattern.lastIndex = 0;
      return;
    }
    arrowPattern.lastIndex = 0;

    const readableText = (control.textContent || '').replace(arrowPattern, '').trim();
    arrowPattern.lastIndex = 0;
    if (!readableText && !control.hasAttribute('aria-label')) {
      control.setAttribute('aria-label', 'Open link');
    }

    const walker = document.createTreeWalker(control, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      if (node.parentElement?.classList.contains('s-vector-arrow')) return;
      const value = node.nodeValue || '';
      if (!arrowPattern.test(value)) {
        arrowPattern.lastIndex = 0;
        return;
      }
      arrowPattern.lastIndex = 0;

      const fragment = document.createDocumentFragment();
      let cursor = 0;
      for (const match of value.matchAll(arrowPattern)) {
        if (match.index > cursor) fragment.append(value.slice(cursor, match.index));
        fragment.append(makeArrow(match[0]));
        cursor = match.index + match[0].length;
      }
      if (cursor < value.length) fragment.append(value.slice(cursor));
      node.replaceWith(fragment);
      arrowPattern.lastIndex = 0;
    });
  }

  function scan(root = document) {
    if (root instanceof Element && root.matches('a, button')) upgradeControl(root);
    root.querySelectorAll?.('a, button').forEach(upgradeControl);
  }

  function start() {
    scan();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) scan(node);
          else if (node.nodeType === Node.TEXT_NODE && node.parentElement?.closest('a, button')) {
            upgradeControl(node.parentElement.closest('a, button'));
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
